import FAQRepositories from "@repositories/faq.repositories"
import { Result } from "@lib/api/services/result"
import { Faq } from "@interfaces/faq"

export default class FaqServices extends FAQRepositories {
  async getFAQList() {
    try {
      const res = await this.getRawFAQList()

      const { error, result } = await this._getResponse<Faq[]>(res)

      if (error || !result) {
        return Result.fail<Faq[]>()
      }

      return Result.ok<Faq[]>(result)
    } catch (e) {
      return Result.fail<Faq[]>()
    }
  }
}
